import { Box, styled, TextField } from '@material-ui/core';
import { SButton } from '@setvi/shared/components';

export const AskAiButton = styled(Box)({
  borderRadius: 120,
  padding: 2,
  background:
    'linear-gradient(180deg, #1E96FC 0%, #7E44FC 31.5%, #57CCF0 100%)',
  display: 'inline-block',

  '& button': {
    borderRadius: 'inherit',
    background: '#f8f9fa',

    '&:hover': {
      background: '#f8f9fa'
    }
  }
});

export const Container = styled(Box)({
  height: '100%',
  width: 350,
  background: '#fff',
  borderRadius: 16,
  border: '1px solid #EEF0F2',
  display: 'flex',
  justifyContent: 'space-between',
  flexDirection: 'column'
});

export const Header = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  padding: '12px 16px',
  gap: 4
});

export const CollapseButton = styled(SButton)({
  minHeight: 32,
  borderRadius: 32,
  fontSize: 12,
  color: '#5D7083',

  '& svg': {
    transform: 'scale(0.8)'
  }
});

export const Content = styled(Box)({
  flex: 1,
  display: 'flex',
  justifyContent: 'flex-start',
  gap: 16,
  padding: 16,
  flexDirection: 'column',
  overflow: 'hidden auto'
});

export const QuestionContainer = styled(Box)({
  display: 'flex',
  gap: 10,
  flexDirection: 'column',
  marginTop: 10
});

export const QuestionButton = styled(Box)({
  borderRadius: 32,
  color: '#20262D',
  fontWeight: 400,
  backgroundColor: '#EBF5FF',
  padding: '8px 16px',
  width: 'fit-content',
  cursor: 'pointer',
  '&:hover': {
    backgroundColor: '#D9EFFF'
  }
});

export const Footer = styled(Box)({
  display: 'flex',
  gap: 10,
  alignItems: 'flex-end',
  padding: '0px 12px 12px 12px'
});

export const MsgContainer = styled(Box)({
  width: '100%',
  display: 'flex'
});

export const QuestionMsg = styled(Box)({
  borderRadius: 32,
  borderBottomRightRadius: 0,
  color: '#20262D',
  fontWeight: 400,
  backgroundColor: '#EEF0F2',
  padding: '8px 16px',
  width: 'fit-content',
  wordBreak: 'break-word'
});

export const QuestionInput = styled(TextField)(({ theme }) => ({
  fontSize: 14,
  flex: 1,
  borderRadius: 24,
  backgroundColor: '#F8F9FA',
  // Set vertical auto resize
  '& .MuiInputBase-root': {
    padding: '6px 16px',
    lineHeight: 1.5,
    borderRadius: 24,
    minHeight: 42
  },
  '& .MuiOutlinedInput-notchedOutline': {
    borderColor: 'transparent'
  },
  '&:hover .MuiOutlinedInput-notchedOutline': {
    borderColor: 'transparent'
  },
  '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
    borderColor: theme.palette.primary.main
  },
  '& .MuiInputBase-input': {
    color: '#000',
    padding: 0,
    fontSize: 14
  },
  '& .MuiInputBase-input::placeholder': {
    color: '#5D7083',
    opacity: 1
  }
}));
